import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  paperContainer: {
    margin: '24px',
    padding: '24px',
    height: '83vh',
    borderRadius: '12px !important',
    boxShadow: 'none !important',
    [theme.breakpoints.down('ultraHD')]: {
      margin: '18px',
      padding: '18px',
      height: '84vh',
      borderRadius: '9px !important',
    },
    [theme.breakpoints.down('fullHD')]: {
      height: '84vh',
    },
    [theme.breakpoints.down('HD')]: {
      height: '82vh',
    },
    [theme.breakpoints.down('xxl')]: {
      height: '80vh',
    },
    [theme.breakpoints.down('xl')]: {
      height: '100%',
    },
  },
  cardContainer: {
    minHeight: '250px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    background: '#F0EDF6',
    padding: '24px',
    borderRadius: '12px',
    gap: '24px',
    cursor: 'pointer',
    [theme.breakpoints.down('ultraHD')]: {
      minHeight: '144px !important',
      padding: '18px',
      borderRadius: '9px',
      gap: '18px',
    },
  },
  cardSubContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    [theme.breakpoints.down('ultraHD')]: {
      gap: '18px',
    },
  },
  cardImg: {
    width: '27px',
    height: '27px',
    objectFit: 'contain',
    borderRadius: '8px',
    [theme.breakpoints.down('ultraHD')]: {
      width: '20px',
      height: '20px',
      borderRadius: '6px',
    },
  },
  cardHeader: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#373A45',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
}));
